import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, secondaryListItems, adminListItems } from './ListItems';
import { BrowserRouter as Router } from 'react-router-dom';
import SwitchRoutes from 'pages/SwitchRoutes';
import {useHistory} from "react-router-dom";
import { sendGetRequest, sendPutRequest } from 'utils/api';
import { UserContext } from "./contexts";
import LockIcon from '@material-ui/icons/Lock';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Blocker from 'components/Blocker';
import { Link } from "react-router-dom";
import _ from 'lodash';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	toolbar: {
		paddingRight: 24, // keep right padding when drawer closed
	},
	toolbarIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		padding: '0 8px',
		...theme.mixins.toolbar,
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: 36,
	},
	menuButtonHidden: {
		display: 'none',
	},
	title: {
		flexGrow: 1,
	},
	drawerPaper: {
		position: 'relative',
		whiteSpace: 'nowrap',
		width: drawerWidth,
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerPaperClose: {
		overflowX: 'hidden',
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		width: theme.spacing(7),
		[theme.breakpoints.up('sm')]: {
			width: theme.spacing(9),
		},
	},
	appBarSpacer: theme.mixins.toolbar,
	content: {
		flexGrow: 1,
		height: '100vh',
		overflow: 'auto',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
		display: 'flex',
		overflow: 'auto',
		flexDirection: 'column',
	},
	fixedHeight: {
		height: 240,
	},
}));




export default function Dashboard() {
	const history = useHistory();
	const classes = useStyles();
	const [open, setOpen] = React.useState(true);
	const [userInfo, setUserInfo] = useState({});
	const [requesting, setRequesting] = useState();
	const [status, setStatus] = useState();
	const [login, setLogin] = useState('SIGN-IN');
	const [count, setCount] = React.useState();
	const [theColor, setTheColor] = React.useState();


	const handleDrawerOpen = () => {
		setOpen(true);
	};
	const handleDrawerClose = () => {
		setOpen(false);
	};

	const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

	const gotoNotifications = (e) =>{
		history.replace('/forapproval');
	}


	const testEmail1 = async () =>{

		const testEmail = async () =>{
			const data = {id: 41, remarks: 'test'};
			const res = await sendPutRequest(`/famas/header/route/41`, data);
		}
		testEmail();
	
	}

	useEffect(()=>{
		if(localStorage.getItem('user')){
			console.log("USER STORAGE FOUND");
			const checkUser = JSON.parse(localStorage.getItem('user'));
			//if(checkUser.role === 'Admin'){
				setLogin('SIGN-OUT');
				setUserInfo({...checkUser})
			//}

			if(_.isEmpty(checkUser)){
				console.log("EMPTY");
				const checkUser  = async () =>{
					console.log("MAIN");
					const table = `/login/checkuser`;
					const res = await sendGetRequest(table);
					
					if(res.data){
						console.log("IF RES DATA");
						setRequesting(false);
						setLogin('SIGN-OUT');
						setUserInfo({...res.data});
						
					}else{
						console.log("ELSE RES DATA");
						if(localStorage.getItem('user')){
							
							const checkUser = JSON.parse(localStorage.getItem('user'));
							if(checkUser.role === 'Admin' && checkUser.offline === true){
								setLogin('SIGN-OUT');
								setUserInfo({...checkUser})
							}
	
						}else{
							setLogin('SIGN-IN');
							setUserInfo({})
						}
						setRequesting(false);	
					}
				}
				//checkUser();
			}

		}else{

			try{
				const checkUser  = async () =>{
					console.log("MAIN");
					const table = `/login/checkuser`;
					const res = await sendGetRequest(table);
					
					if(res.data){
						console.log("IF RES DATA");
						setRequesting(false);
						setLogin('SIGN-OUT');
						setUserInfo({...res.data});
						
					}else{
						console.log("ELSE RES DATA");
						if(localStorage.getItem('user')){
							
							const checkUser = JSON.parse(localStorage.getItem('user'));
							if(checkUser.role === 'Admin' && checkUser.offline === true){
								setLogin('SIGN-OUT');
								setUserInfo({...checkUser})
							}
							if(checkUser.role !== 'Admin'){
								setLogin('SIGN-OUT');
								setUserInfo({...checkUser})
							}
	
						}else{
							setLogin('SIGN-IN');
							setUserInfo({})
						}
						setRequesting(false);	
					}
				}
				checkUser();
			}catch(err){
					
			}
		}
	},[])

	const checkapprv = async () =>{

		//const resForApproval = await sendGetRequest(`/notification/details`);

		const resForApproval = await sendGetRequest(`/notification/subdetails/all`);

		if (resForApproval.error) {
			alert('Encountered an error while getting pending item(s) under your account.');
			return;
		}

		console.log("DATA FETCHED FROM THE SERVER: ", resForApproval.data)
		console.log("COUNT: ", resForApproval.data.length)
	
		if(resForApproval.data.length > 0){
			setCount(resForApproval.data.length);
			setTheColor('secondary')
		}else {
			setCount('');
			setTheColor('')
		}
		
	}
	
	useEffect(()=>{
		//if(_.isEmpty(userInfo)) return;

		//INITIALIZE LOCAL STORAGE
		if(login === 'SIGN-OUT' && !_.isEmpty(userInfo)){
			
			setRequesting(true);
			
			checkapprv();

			localStorage.setItem('user', JSON.stringify(userInfo));

			if(!localStorage.getItem('location')){
				const path = `/misc?config_type=location`;
				sendGetRequest(path).then((res) => {
					const tempLocations = [];
					if (res.error) {
						setRequesting(false);
						return;
					}
	
					
					for(const locations of res.data){
						tempLocations.push({id: locations.idMaster, value: locations.configName})
					}	
					//setLocations(tempLocations);
					localStorage.setItem('location', JSON.stringify(tempLocations));
				});
			}
			
			if(!localStorage.getItem('assetStat')){
				const pathAssetStats = `/misc?config_type=assetstat`;
				sendGetRequest(pathAssetStats).then((res) => {
				const tempLocations = [];
				if (res.error) {
					setRequesting(false);
					return;
				}

				for(const locations of res.data){
					tempLocations.push({id: locations.idMaster, value: locations.configName})
				}	
				//setLocations(tempLocations);
				localStorage.setItem('assetStat', JSON.stringify(tempLocations));
				});	
			}
			
			if(!localStorage.getItem('depts')){
				const pathDepts = `/depts`;
				setRequesting(true);
				sendGetRequest(pathDepts).then((res) => {
					const departments = [];
	
					setRequesting(false);
					if (res.error) {
						return;
					}
					 
					for(const department of res.data){
						console.log("DEPARTMENT NAME: ", department.deptName);
						departments.push({id: department.idMaster, value: department.deptName})
					}
					
					let byValue = departments.slice(0);
					if(byValue.length>0){
						let keysSorted = byValue.sort(function(a,b){
							let x = a.value.toLowerCase();
							let y = b.value.toLowerCase();
							return x < y ? -1 : x > y ? 1 : 0;
						});
						localStorage.setItem('depts', JSON.stringify(keysSorted));
					}
					
				});
			}
			

			if(!localStorage.getItem('plantSite')){
				console.log("Checking PlantSite");
				const pathPlantSite = `/misc?config_type=PlantSite`;
				sendGetRequest(pathPlantSite).then((res) => {
					
					const items = [];
					setRequesting(false);
					if (res.error) {
						return;
					}
					for(const item of res.data){
						items.push({id: item.idMaster, value: item.configName})
					}
					let byValue = items.slice(0);
					if(byValue.length>0){
						let keysSorted = byValue.sort(function(a,b){
							let x = a.value.toLowerCase();
							let y = b.value.toLowerCase();
							return x < y ? -1 : x > y ? 1 : 0;
						});
						localStorage.setItem('plantSite', JSON.stringify(keysSorted));
					}
					
				});
			}
			

			if(!localStorage.getItem('buildingStructure')){
				const pathBuildingStructure = `/misc?config_type=BuildingStructure`;
				setRequesting(true);
				sendGetRequest(pathBuildingStructure).then((res) => {
					const items = [];
					setRequesting(false);
					if (res.error) {
						return;
					}
					for(const item of res.data){
						items.push({id: item.idMaster, value: item.configName})
					}
					let byValue = items.slice(0);
					if(byValue.length>0){
						let keysSorted = byValue.sort(function(a,b){
							let x = a.value.toLowerCase();
							let y = b.value.toLowerCase();
							return x < y ? -1 : x > y ? 1 : 0;
						});
						localStorage.setItem('buildingStructure', JSON.stringify(keysSorted));
					}
				});
	
			}
			
			if(!localStorage.getItem('room')){
				const pathRoom = `/misc?config_type=Room`;
				setRequesting(true);
				sendGetRequest(pathRoom).then((res) => {
					const items = [];
					setRequesting(false);
					if (res.error) {
						return;
					}
					for(const item of res.data){
						items.push({id: item.idMaster, value: item.configName})
					}
					let byValue = items.slice(0);
					if(byValue.length>0){
						let keysSorted = byValue.sort(function(a,b){
							let x = a.value.toLowerCase();
							let y = b.value.toLowerCase();
							return x < y ? -1 : x > y ? 1 : 0;
						});
						localStorage.setItem('room', JSON.stringify(keysSorted));
					}
					
				});
			}

			if(!localStorage.getItem('AssetStat')){
				const pathRoom = `/misc?config_type=AssetStat`;
				setRequesting(true);
				sendGetRequest(pathRoom).then((res) => {
					const items = [];
					setRequesting(false);
					if (res.error) {
						return;
					}
					for(const item of res.data){
						items.push({id: item.idMaster, value: item.configName})
					}
					localStorage.setItem('AssetStat', JSON.stringify(items));
				});
			}
			
			if(!localStorage.getItem('businessUnits')){
				const pathBusinessUnit = `/company`;
				setRequesting(true);
				sendGetRequest(pathBusinessUnit).then((res) => {
					const items = [];
					setRequesting(false);
					if (res.error) {
						return;
					}
					for(const item of res.data){
						items.push({id: item.companyName, value: item.companyName})
					}
					localStorage.setItem('businessUnits', JSON.stringify(items));
				});
			}
			
			setRequesting(false);
		}

	},[userInfo])

	const UserContextValues = {
		userInfo, setUserInfo
	}

	const loginUser = (e) =>{
		localStorage.removeItem('user');
		setUserInfo({});
		window.location.replace(`${process.env.REACT_APP_API_LOGIN}`);
	}

	const logOut = async () =>{
		
		try {	
			setRequesting(true);

			await sendGetRequest(`/login/logout`);

			localStorage.removeItem('user');
			setLogin("SIGN-IN");
			setUserInfo({});
			setRequesting(false);

			window.location.replace('/');
		}
		catch (e) { 
			console.log(e); 
			setRequesting(false);
		}
		 
	}

	return (
		<UserContext.Provider value = {UserContextValues} >
		<Router>
		
		<div className={classes.root}>
			<Blocker open={requesting} />
			<CssBaseline />
			<AppBar
				position="absolute"
				className={clsx(classes.appBar, open && classes.appBarShift)}
			>
				<Toolbar className={classes.toolbar}>
					<IconButton
						edge="start"
						color="inherit"
						aria-label="open drawer"
						onClick={handleDrawerOpen}
						className={clsx(
							classes.menuButton,
							open && classes.menuButtonHidden
						)}
					>
						<MenuIcon />
					</IconButton>
					<Typography
						component="h1"
						variant="h6"
						color="inherit"
						noWrap
						className={classes.title}
					>
						ADMIN SCM - EAMS
					</Typography>
					<Link color="inherit" to="/forapproval">
						<IconButton color="inherit">
							<Badge badgeContent={count} color={theColor}>
								<NotificationsIcon/>
							</Badge>
						</IconButton>
					</Link>
				</Toolbar>
			</AppBar>
			<Drawer
				variant="permanent"
				classes={{
					paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
				}}
				open={open}
			>
				<div className={classes.toolbarIcon}>
					<IconButton onClick={handleDrawerClose}>
						<p style={{"fontSize":"12px","fontWeight":"bold","paddingRight":"10px","color":"black"}}>{userInfo.user}</p>
						<ChevronLeftIcon />
					</IconButton>
				</div>
				<Divider />
				{
					login === 'SIGN-IN' ? null :
					<List>{mainListItems}</List>
				}

				{
					login === 'SIGN-IN' ? null :
					userInfo.role === 'Admin' ? <List>{adminListItems}</List> : null
				}
				
				<Divider />
				{
					login === 'SIGN-IN' ? null :
					<List>{secondaryListItems}</List>
				}
				
				<Divider />
				{
					login === 'SIGN-OUT' ?  
					<ListItem button>
					<ListItemIcon>
						<LockIcon />
					</ListItemIcon>
					<ListItemText primary='SIGN-OUT' onClick = { (e) => { logOut(e) } } />
					</ListItem>
					:
					<ListItem button>
					<ListItemIcon>
						<LockIcon />
					</ListItemIcon>
					<ListItemText primary='SIGN-IN' onClick = { (e) => { 
						loginUser(e);
					} } />
					</ListItem>
				}
				</Drawer>
				<main className={classes.content}>
					<div className={classes.appBarSpacer} />
					<Container maxWidth="lg" className={classes.container}>
						<SwitchRoutes />
					</Container>
				</main>	

		</div>
		
		</Router>
		</UserContext.Provider>
	);
}
